"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorybookFakeWidget = StorybookFakeWidget;
exports.supportMocking = supportMocking;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function StorybookFakeWidget(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    children = _ref.children;
  return _react.default.createElement("div", {
    className: className || 'storybook-fake',
    style: _objectSpread({
      width: Number.isFinite(width) ? width + 'px' : width,
      height: Number.isFinite(height) ? height + 'px' : height,
      flexShrink: width || height ? 0 : null
    }, style)
  }, children);
}
function supportMocking(Widget, View) {
  // Enable faking in Storybook
  if (process.env.NODE_ENV === 'development') {
    return function Faker(props) {
      var storybookFake = props.storybookFake;
      if ((0, _isObject2.default)(storybookFake) && storybookFake.type === StorybookFakeWidget) {
        return storybookFake;
      }
      if (storybookFake === true) {
        return _react.default.createElement(StorybookFakeWidget, null, View.name.replace(/View$/, ''));
      }
      if (storybookFake) {
        return _react.default.createElement(View, storybookFake);
      }
      return _react.default.createElement(Widget, props);
    };
  }
  return Widget;
}